module.exports = __webpack_public_path__ + "static/media/button-AddProspect.016bc36e.png";